// React
import React from 'react';
// Material-UI
import { Button } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
// Otras libs

// Componentes

// Funciones

// Hooks


/**
 * Especifica la función a ser ejecutada al hacer click en el botón
 * @callback OnClick
 * @param {React.MouseEventHandler<HTMLButtonElement>} event Evento de botón
 * @returns {Promise<bool>}
 */

/**
 *
 * @typedef {Object} Props
 * @property {string} label Etiqueta de botón
 * @property {OnClick} onClick Evento al presionar botón
 */

/**
 * Botón de acción
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const BotonAccion = ({ 
    label = '',
    onClick = (event) => {},
}) => {
    // Idioma

    // Estados
    

    // Vista
    return (
        <Button
            variant="contained"
            disableElevation
            endIcon={<ArrowForwardIcon />}
            color="primary"
            onClick={onClick}
        >
            {label}
        </Button>
    );
};
